<button
  type="button"
  class="anchor-chip"
  [ngClass]="{ 'is-active': isActive, 'is-loading': loading }"
  [disabled]="loading"
  [attr.aria-label]="loading ? 'Loading creatives' : 'Show ' + creativeCount + ' creatives in the library'"
  (click)="onClick()">
  <ng-container *ngIf="!loading; else skeleton">
    <span class="chip-logos" *ngIf="visibleLogos.length">
      <img *ngFor="let logo of visibleLogos" class="chip-logo" [src]="logo" alt=""/>
      <span class="chip-logo chip-logo-overflow" *ngIf="hiddenLogoCount > 0">+{{ hiddenLogoCount }}</span>
    </span>
    <span class="chip-count" *ngIf="creativeCount > 0">{{ creativeCount }}</span>
  </ng-container>
  <ng-template #skeleton>
    <span class="chip-logos">
      <span class="chip-logo skeleton-pulse"></span>
    </span>
    <span class="chip-count" *ngIf="creativeCount > 0">{{ creativeCount }}</span>
  </ng-template>
</button>
